"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnDragLeaveTreeHandler = exports.useOnDragEnterTreeItemHandler = void 0;
var react_1 = require("react");
var ControlledTreeEnvironment_1 = require("./ControlledTreeEnvironment");
var use_stable_handler_1 = require("../use-stable-handler");
var useOnDragEnterTreeItemHandler = function (setDragCode, draggingItems, itemHeight, onDragAtPosition, onPerformDrag, treeId, incrementDragCount) {
    var _a = (0, ControlledTreeEnvironment_1.useTreeEnvironment)(), canDropOnFolder = _a.canDropOnFolder, canDropOnNonFolder = _a.canDropOnNonFolder, canDragAndDrop = _a.canDragAndDrop, linearItems = _a.linearItems, items = _a.items, trees = _a.trees;
    return (0, use_stable_handler_1.useStableHandler)(function (e) {
        if (e.dataTransfer.types.includes("Files")) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        incrementDragCount();
        if (!treeId || !draggingItems || !canDragAndDrop) {
            return;
        }
        if (linearItems[treeId].length === 0) {
            // Empty tree
            onPerformDrag({
                targetType: "root",
                treeId: treeId,
                targetItem: trees[treeId].rootItem,
            });
            return;
        }
        var dataset = e.currentTarget.dataset;
        var itemId = dataset.rctIsFolder === "true"
            ? dataset.rctItemId
            : dataset.rctIsFolder === "false"
                ? dataset.rctParentId
                : undefined;
        if (!itemId) {
            setDragCode("outside");
            onDragAtPosition(undefined);
            return;
        }
        var nextDragCode = "".concat(treeId).concat(itemId);
        var isDragCodeChanged = setDragCode(nextDragCode);
        if (!isDragCodeChanged) {
            return;
        }
        var targetItemData = items[itemId];
        if (!canDropOnNonFolder && !targetItemData.isFolder) {
            onDragAtPosition(undefined);
            return;
        }
        if (!canDropOnFolder && targetItemData.isFolder) {
            onDragAtPosition(undefined);
            return;
        }
        if (draggingItems.some(function (draggingItem) { return draggingItem.index === targetItemData.index; })) {
            onDragAtPosition(undefined);
            return;
        }
        onPerformDrag({
            targetType: "item",
            treeId: treeId,
            targetItem: itemId,
        }, e.currentTarget);
    });
};
exports.useOnDragEnterTreeItemHandler = useOnDragEnterTreeItemHandler;
var useOnDragLeaveTreeHandler = function (incrementDragCount) {
    return (0, react_1.useCallback)(function (_e) {
        incrementDragCount(true);
    }, [incrementDragCount]);
};
exports.useOnDragLeaveTreeHandler = useOnDragLeaveTreeHandler;
